import ToggleGroupComponent from 'components/ToggleGroup';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import React from 'react';
import { platforms } from 'utils/configs';
import AccessRulesList from '../../App/OrgView/AccessRulesList';

const OrganizationForm = ({ data, onChangeData }: IOrganizationForm) => {
  const [orgIdEditDisabled, setOrgIdEditDisabled] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (data.orgId) setOrgIdEditDisabled(true);
  }, []);

  return (
    <div className="grid gap-y-4">
      <div>
        <Label htmlFor="id">Org id (leave empty for UUID)</Label>
        <Input
          type="text"
          id="id"
          className="w-100"
          value={data.orgId || ''}
          onChange={e => onChangeData('orgId', e.target.value)}
          placeholder="Org id"
          disabled={orgIdEditDisabled}
        />
      </div>
      <div>
        <Label htmlFor="displayName">Display name</Label>
        <Input
          type="text"
          id="displayName"
          className="w-100"
          value={data.displayName || ''}
          onChange={e => onChangeData('displayName', e.target.value)}
          placeholder="Display name"
        />
      </div>
      <div>
        <Label htmlFor="orgGroup">Org group</Label>
        <Input
          type="text"
          id="orgGroup"
          className="w-100"
          value={data.orgGroup || ''}
          onChange={e => onChangeData('orgGroup', e.target.value)}
          placeholder="Org group"
        />
      </div>
      <div>
        <ToggleGroupComponent
          value={data['platforms'] || ([] as string[])}
          onChange={plats => onChangeData('platforms', plats)}
          options={platforms as unknown as string[]}
          header={'Platforms'}
        />
      </div>
      <div>
        <Label htmlFor="externalAdmissionGroups">External admission groups (optional, separate with commas)</Label>
        <Input
          type="text"
          id="externalAdmissionGroups"
          className="w-100"
          value={data.externalAdmissionGroups || ''}
          onChange={e => onChangeData('externalAdmissionGroups', e.target.value)}
          placeholder="External admission groups"
        />
      </div>
      <div>
        <Label htmlFor="autocreateAlternateIdTypes">
          Autocreate alternate ID types (optional, separate with commas)
        </Label>
        <Input
          type="text"
          id="autocreateAlternateIdTypes"
          className="w-100"
          value={data.autocreateAlternateIdTypes || ''}
          onChange={e => onChangeData('autocreateAlternateIdTypes', e.target.value)}
          placeholder="Autocreate alternate ID types"
        />
      </div>

      {data.orgId && <AccessRulesList data={{ organization: data.orgId }} />}
    </div>
  );
};

interface IOrganizationForm {
  data: Partial<IOrganizationFormData>;
  onChangeData: (field: keyof IOrganizationForm['data'], value: string | string[]) => void;
}

export default OrganizationForm;
